import fetchBff from 'crypto-fetch/bff'
import { useSportsStore } from '@ms/stores/sports'
import { useSportsLiveStore } from '@ms/stores/sportsLive'
import useHomeStore from './index.js'
import { useLayoutStore } from 'wap/stores/layout'
import { useGameCardsStore } from '@ms/stores/gameCards'

export default async function useBffHome(reqList = []) {
  const bffApiList = [
    {
      uri: '/facts-center/query/frontend/focus-matches/v2',
      callback: useHomeStore().getFeaturedMatches
    },
    {
      uri: '/common/config/broadcast',
      callback: useLayoutStore().setNotice
    },
    {
      uri: '/highfreq/games-lobby/game-cards',
      callback: useGameCardsStore().getGamesCards
    },
    {
      uri: '/facts-center/query/frontend/live-matches/sports',
      callback: useSportsLiveStore().setBffLiveSports
    },
    {
      uri: '/facts-center/query/frontend/sports-a-z-menu',
      parameters: {
        product: 3
      },
      callback: useSportsStore().setBffPrematchSports
    }
  ]

  return fetchBff([...bffApiList, ...reqList])
}
